import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
//import { GatsbyImage } from "gatsby-plugin-image"

const FeatureSecondaryProducts = () => {
  const data = useStaticQuery(
    graphql`
      {
        allWpPost(
          filter: {
            categories: {
              nodes: { elemMatch: { name: { eq: "other featured" } } }
            }
          }
        ) {
          nodes {
            id
            title
            excerpt
            uri
            featuredImage {
              node {
                altText
                sourceUrl
                srcSet
              }
            }
          }
        }
      }
    `
  )

  const { allWpPost } = data
  //const image = getImage(data.localFile.childImageSharp.gatsbyImageData)
  return (
    <div className='featured-secondary-container mx-auto mt-3 mb-5'>
      <h3 className='text-center fs-2'>
        Productos para <span className='text-danger'>profesionales</span> contra
        el fuego
      </h3>
      <p className='col-11 col-md-9 text-center'>
        Las unidades móviles Amerex tienen una gran capacidad para combatir
        incendios de gran proporción y siempre protegiendo al usuario. Estos
        extintores ofrecen alto volumen de flujo a una mayor distancia.
      </p>
      {/* product cards */}
      <div className='card-group col-12 col-md-10'>
        {allWpPost.nodes.map(({ id, title, featuredImage, excerpt, uri }) => (
          <div key={id} className='card border-0'>
            <img
              src={featuredImage.node.sourceUrl}
              srcSet={featuredImage.node.srcSet}
              className='card-img-top img-fluid'
              alt={featuredImage.node.altText}
            />
            {/* <GatsbyImage
              image={
                featuredImage.node.localFile.childImageSharp.gatsbyImageData
              }
              alt={featuredImage.node.altText}
            /> */}
            <div className='card-body'>
              <p className='card-title text-center fw-bold lead fs-6 m-0 text-uppercase'>
                {title}
              </p>
              <p className='card-text text-center ellipsis'>
                {excerpt.replace(/(<([^>]+)>)/gi, ' ')}
              </p>
              <div className='d-grid gap-2'>
                <Link className='btn btn-danger fs-6' type='button' to={uri}>
                  Ver detalles
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FeatureSecondaryProducts
